module.exports = __webpack_public_path__ + "static/media/horse.e3be4c40.png";